<template>
  <div class="container">
    <div class="col-12 text-center g" v-if="!loaded">
      <button class="btn btn-primary btn-lg" @click="gett(); loaded = true">
        <i class="fa fa-list"></i>
        عرض الاحصائيات
      </button>
    </div>
    <div class="row" v-if="loaded">
      <div class="col-12 col-lg-2 c" v-for="s in stats.cards" :key="s.title">
        <div class="card card-body text-center">
            <h1>
              {{ s.count }}
            </h1>
            {{ s.title }}
        </div>
      </div>
      <div class="col-12 col-lg-4">
        <div class="card card-body">
          <div class="table-responsive col-12">
            <p>
            احصائيات الداتا بيز
          </p>
          <table class="table table-hover table-bordered table-sm">
            <thead>
              <th>
                اسم الجدول
              </th>
              <th>
                عدد السجلات
              </th>
            </thead>
            <tbody>
              <tr v-for="table in stats.tables" :key="table.title">
                <td>
                  {{ table.title.replace('.js', '') }}
                </td>
                <td>
                  {{ table.count }}
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>
      <div class="col-12 col-lg-8">
        <div class="card card-body">
          <div class="table-responsive col-12">
            <p>
            احصائيات الخدمات
          </p>
          <table class="table table-hover table-bordered table-sm">
            <thead>
              <th>
                الخدمة
              </th>
              <th>
                فعالة تجربة
              </th>
              <th>
                فعالة شراء
              </th>
              <th>
                منتهية
               تجربة
              </th>
              <th>
                منتهية
                 شراء
              </th>
            </thead>
            <tbody>
              <tr v-for="service in stats.services" :key="service.title">
                <td>
                  {{ service.title }}
                </td>
                <td>
                  {{ service.active_demo }}
                </td>
                <td>
                  {{ service.active_pay }}
                </td>
                <td>
                  {{ service.end_demo }}
                </td>
                <td>
                  {{ service.end_pay }}
                </td>
              </tr>
            </tbody>
          </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return {
      jwt: localStorage.getItem("jwt"),
      stats: {
        cards: []
      },
      loaded: false
    }
  },
  methods: {
    gett(){
      var g = this;
      $.post(api + '/admin/stats', {
        jwt: this.jwt
      }).then(function(a){
        g.stats = a.response
      })
    }
  }
}
</script>

<style>

</style>